import { lazy, Suspense } from 'react';

import { Switch } from 'react-router-dom';

import AuthenticatedRoute from 'apps/admin/components/AuthenticatedRoute';

const ProspectListPage = lazy(
  () => import('apps/admin/components/ProspectSurvey/ProspectListContainer'),
);
const ProspectDetailPage = lazy(
  () => import('apps/admin/components/ProspectSurvey/ProspectSurveyDetailPage'),
);

export default function ProspectSurveyRoutes() {
  return (
    <Switch>
      <AuthenticatedRoute exact path="/prospect-survey">
        <Suspense fallback={null}>
          <ProspectListPage />
        </Suspense>
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path="/prospect-survey/new">
        <Suspense fallback={null}>
          <ProspectDetailPage isNew />
        </Suspense>
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path="/prospect-survey/:id">
        <Suspense fallback={null}>
          <ProspectDetailPage />
        </Suspense>
      </AuthenticatedRoute>
    </Switch>
  );
}
